import React, { FC, useEffect, useState } from "react";
import { ActivityIndicator, DeviceEventEmitter, Keyboard, Pressable, RefreshControl, TouchableOpacity, View, VirtualizedList, useWindowDimensions } from "react-native";
import { ThemeConsumer } from "@rneui/themed";
import Popover from "react-native-popover-view/dist/Popover";

import { config } from "../../../shared/environment";
import { appColors } from "../../../themes/appTheme";
import CommonHeader from "../../../shared/commonComponents/commonHeader";
import CommonDialogBox from "../../../shared/commonComponents/commonDialogBox";


import { ZenBadge, ZenButton, ZenFilterModal, ZenIcon, ZenToast, ZenText, ZenLoader, ZenSearchBar, ZenEmptyComponent } from "zen-core-elements";

import { getScreenPermission, useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useAppNavigation } from "../../../types/@react-navigation/navigation";
import { filterItemsProps } from "zen-core-elements/src/elements/zenFilterModal/zenFilterType.modal";

import { useKeyborad } from "../../../shared/hooks/useKeyborad";
import { deleteOneZone, getAllZone } from "../../../redux/slices/zoneSlice";
import { GetAllZoneData } from "./zoneModule";
import { ListToolbar } from "../../../shared/commonComponents/listToolbar";
import { shallowEqual } from "react-redux";
import { showApiError } from '../../../shared/utils/handleApiError';

let limit = 20
const ZoneList: FC = () => {
    const { isWrite: isSetttingWrite } = useAppSelector(getScreenPermission("SettingStack"), shallowEqual)
    //variable to hold the screen width
    const { width } = useWindowDimensions()
    const { row: zoneData, count: total, isRefresh } = useAppSelector((state) => state?.zoneSlice.zoneList)
    //variable used to store navigation
    const navigation = useAppNavigation()
    //used to dispatch actions
    const dispatch = useAppDispatch()
    //variable used to store footer loader
    const [footerLoader, setFooterLoader] = useState<boolean>(false)
    //variable used to store refresh loader
    const [refresh, setRefresh] = useState<boolean>(false)
    //variable used to store page loader
    const [loader, setLoader] = useState<boolean>(false)
    //variable used to store search text
    const [search, setSearch] = useState<string | null>(null)
    //variable to open/close delete popover
    const [confirmationPopover, setConfirmationPopover] = useState<{ isVisible: boolean, id?: number }>({ isVisible: false })
    //Variable used to open/close filter
    const [openFilter, setOpenFilter] = useState<boolean>(false)
    //variable to store filter payload
    const [filterPayLoad, setFilterPayLoad] = useState<string | null>(null)
    //Variable used to store filter count
    const [filtercount, setFilterCount] = useState(0)
    const [offset, setOffset] = useState<number | null>(null)
    //variable for handle keyboard
    const keyboardOpen = useKeyborad()

    //Method for toggle offset value
    const toggleOffsetValue = () => {
        setOffset((preset) => (preset === 0 ? -1 : 0))
    }

    //filter data values
    const [filterData, setFilterData] = useState<filterItemsProps[]>([
        {
            id: '1',
            filterName: 'Medium',
            filterType: "radio",
            filterValue: [
                {
                    value: 'WEB',
                    label: 'Admin',
                },
                {
                    value: 'POS',
                    label: 'POS',
                }
            ],
            initialSelected: ''
        }
    ])
    //variable to store the delete confirmation dialog
    const deleteDialogProps = {
        content: "Are you sure you want to delete this zone?",
        button: [{ id: 1, name: "Okay" }, { id: 2, name: "Cancel" }],
        icon: {
            name: 'alert-outline', size: 55, color: appColors.warning, type: 'material-community'
        }
    }

    //useEffect to render initially
    useEffect(() => {
        if (!zoneData?.length) {
            setLoader(true)
        }
        toggleOffsetValue()
    }, [isRefresh])

    useEffect(() => {
        if (offset !== null) {
            getAllZoneList()
        }
    }, [offset])

    useEffect(() => {
        if (filterPayLoad?.length) {
            setLoader(true)
            toggleOffsetValue()
        }
    }, [filterPayLoad])

    //useEffect which gets triggered when searchText changes
    useEffect(() => {
        if (search) {
            const debounceSearchText = setTimeout(() => {
                toggleOffsetValue()
            }, 1000);
            return () => { clearTimeout(debounceSearchText) }
        }
        else if (search == "") {
            toggleOffsetValue()
        }
    }, [search])

    //function used to get all bill list
    const getAllZoneList = () => {
        let payload = {
            storeId: config?.storeId,
            searchText: search || "",
            limit,
            offset: (!offset || offset == -1) ? 0 : offset,
            filterData: filterPayLoad || null
        }
        dispatch(getAllZone({ data: payload, storeId: config.storeId })).unwrap().catch(showApiError).finally(() => {
            setLoader(false);
            setFooterLoader(false);
            setRefresh(false);
        })
    }

    // //function used to delete bill
    const deleteBill = (billId: number) => {
        setLoader(true)
        let props = { storeId: config?.storeId, zoneId: billId }
        dispatch(deleteOneZone(props)).unwrap().then((deleteRes) => {
            if (deleteRes) {
                ZenToast({ type: "success", message: "Zone deleted successfully" })
                toggleOffsetValue()
            }
        }).catch(() => {
            ZenToast({ type: "error", message: "Failed to delete a zone" })
            setLoader(false)
        })
    }

    const handleConfirmation = (item: { id: number }) => {
        let billId = confirmationPopover?.id!!
        setConfirmationPopover({ isVisible: false })
        if (item?.id == 1) {
            deleteBill(billId)
        }
    }


    const renderItem = ({ item, index }: { item: GetAllZoneData[], index: number }) => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    <View key={index} style={{ flexDirection: "row" }}>
                        {item?.map((zone, ResponseDataIndex: number) => (
                            <View key={ResponseDataIndex} style={{ flex: 1 / (width > 600 ? 2 : 1) }}>
                                <View style={{
                                    marginBottom: 10,
                                    marginHorizontal: 10,
                                    padding: 10,
                                    borderRadius: 5,
                                    backgroundColor: theme.light,
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between"
                                }}>
                                    <View style={{ flexDirection: "row", alignItems: "center", gap: 10, flex: 1 }}>
                                        <View style={{ gap: 5, flex: 1 }}>
                                            <ZenText content={"Zone Name"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
                                            <ZenText content={zone?.zoneName} size={theme?.smallFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark }} />
                                        </View>
                                        <View style={{ gap: 5, flex: 1 }}>
                                            <ZenText content={"Medium"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
                                            <ZenBadge
                                                badgeColor={zone?.medium == "POS" ? theme?.customerStatus?.wholesaleStatus : theme?.customerStatus?.typeWholesalecolor}
                                                badgeName={zone?.medium}
                                                badgeTextColor={theme?.light}
                                                badgeTextSize={"small"}
                                                badgeTextStyle={{ fontFamily: theme?.bold, padding: 2 }}
                                            />
                                        </View>
                                    </View>
                                    <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
                                        <TouchableOpacity onPress={() => {
                                            navigation.navigate("addUpdateZone", { id: zone?.id })
                                        }}>
                                            <ZenIcon
                                                name={isSetttingWrite ? 'pencil' : "eye"}
                                                type='octicon'
                                                color={theme?.iconColor}
                                                size={theme?.iconSize}
                                                style={{
                                                    "padding": 10,
                                                    "backgroundColor": theme.lightBackgroundColor,
                                                    "borderRadius": 10
                                                }}
                                            />
                                        </TouchableOpacity>
                                        {isSetttingWrite && <TouchableOpacity onPress={() => {
                                            setConfirmationPopover({ isVisible: true, id: zone?.id })
                                        }}>
                                            <ZenIcon
                                                name='delete-outline'
                                                type='material-community'
                                                color={theme?.red}
                                                size={theme?.iconSize}
                                                style={{
                                                    "padding": 10,
                                                    "backgroundColor": theme.lightBackgroundColor,
                                                    "borderRadius": 10
                                                }}
                                            />
                                        </TouchableOpacity>}
                                    </View>
                                </View>
                            </View>
                        ))}
                    </View>
                )
                }
            </ThemeConsumer >
        )
    }

    const getItem = (item: any[], index: number) => {
        let array: any = [];
        let numOfColumns = (width > 600 ? 2 : 1)
        for (let i = 0; i < numOfColumns; i++) {
            let temp = item?.[index * numOfColumns + i];
            temp && array?.push(temp);
        }
        return array;
    };

    const footerComponent = () => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    footerLoader ?
                        <View>
                            <ActivityIndicator size={"small"} color={theme?.primary} />
                        </View >
                        : undefined
                )}
            </ThemeConsumer>
        )
    }

    const onRefresh = () => {
        setRefresh(true)
        DeviceEventEmitter?.emit("clearFilter")
        setSearch(null)
        setFilterPayLoad(null)
        toggleOffsetValue()
    }
    const onEndReached = () => {
        let offsetValue = (offset && offset != -1) ? offset : 0
        if ((total > offsetValue) && !footerLoader) {
            setFooterLoader(true)
            setOffset(limit + offsetValue)
        }
    }
    return (
        <ThemeConsumer>
            {({ theme }) => (
                <View style={{ flex: 1, backgroundColor: theme.lightBackgroundColor }}>
                    <CommonHeader headerName="Zone List" backIcon backIconOnpress={() => { navigation.goBack() }} />
                    <View style={{ flex: 1 }}>
                        <ListToolbar
                            search={{
                                value: search ?? "",
                                onChange: (val) => { setLoader(true), setSearch(val as string) },
                                onCancel: () => { setLoader(true); setSearch(null); toggleOffsetValue(); Keyboard?.dismiss() },
                                placeholder: "Search by zone",
                            }}
                            filter={{
                                count: filtercount ?? 0,
                                onPress: () => setOpenFilter(true),
                            }}
                            buttons={isSetttingWrite ? [{
                                onPress: () => {
                                    navigation.navigate("addUpdateZone")
                                },
                                title: 'Create Zone',
                                variant: "primary"
                            }] : []}
                        />
                        {(loader && !refresh && !footerLoader) ?
                            <ZenLoader lottie={require('../../../assets/infinityLoader.json')} lottieType='Local' viewStyle={{ backgroundColor: "transparent" }} /> :
                            <View style={{ flex: 1 }}>
                                <VirtualizedList
                                    keyExtractor={(_: any, index: number) => index?.toString()}
                                    getItemCount={(data: any) => data?.length}
                                    getItem={getItem}
                                    scrollEnabled={true}
                                    nestedScrollEnabled={true}
                                    renderItem={renderItem}
                                    data={zoneData || []}
                                    keyboardDismissMode="on-drag"
                                    showsVerticalScrollIndicator={false}
                                    onEndReachedThreshold={0.01}
                                    contentContainerStyle={[{ paddingBottom: zoneData.length ? 10 : undefined, flex: zoneData?.length ? undefined : 1 }]}
                                    ListFooterComponent={footerComponent}
                                    ListFooterComponentStyle={{ height: zoneData.length ? 70 : 0 }}
                                    ListEmptyComponent={<ZenEmptyComponent viewStyle={{ backgroundColor: theme?.light }} />}
                                    onEndReached={onEndReached}
                                    refreshControl={<RefreshControl refreshing={refresh} onRefresh={onRefresh} />}
                                />
                            </View>
                        }
                    </View>
                    {
                        width < 600 && !keyboardOpen && isSetttingWrite &&
                        <Pressable style={{ position: "absolute", backgroundColor: theme.primary, width: 50, height: 50, borderRadius: 32, bottom: 40, right: 40, justifyContent: 'center', alignItems: "center" }}
                            onPress={() => { navigation.navigate('CreateBill') }}>
                            <ZenIcon type="material-community" name={"plus"} size={24} color={theme.light} />
                        </Pressable>
                    }
                    <ZenFilterModal
                        setVisible={setOpenFilter}
                        visible={openFilter}
                        filterItems={filterData}
                        setFilterItems={setFilterData}
                        filterCount={filtercount}
                        setFilterCount={setFilterCount}
                        title="Bill List Filter"
                        isSingleExpand={false}
                        onConfirm={(val) => {
                            let data: { medium?: "POS" | "WEB" } = {}
                            if (val?.values?.Medium) {
                                data.medium = val?.values?.Medium
                            }
                            if (Object.keys(data)?.length) {
                                setFilterPayLoad(JSON.stringify(data))
                            } else {
                                setLoader(true)
                                setFilterPayLoad(null)
                                toggleOffsetValue()
                            }
                        }}
                    />

                    <Popover isVisible={confirmationPopover?.isVisible} popoverStyle={{ width: width > 900 ? 500 : 450, borderRadius: 10 }}>
                        <CommonDialogBox type='OTHER' dialog={deleteDialogProps} confirmation={handleConfirmation} />
                    </Popover>
                </View>
            )}
        </ThemeConsumer>
    )
}
export default ZoneList